import {
  FETCH_LEAVE_TYPES_REQUEST, FETCH_LEAVE_TYPES_SUCCESS, FETCH_LEAVE_TYPES_FAIL,
  FETCH_USER_LEAVE_TYPES_REQUEST, FETCH_USER_LEAVE_TYPES_SUCCESS, FETCH_USER_LEAVE_TYPES_FAIL,
  CLEAR_USER_LEAVE_TYPES,
} from "../../constants/Leave/LeaveTypeConstants";

const initialState = {
  loading: false,
  data: [],            // master list
  error: null,
  userLoading: false,
  userData: [],        // types allocated to the employee picked in the dialog
  userError: null,
};

const LeaveTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEAVE_TYPES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LEAVE_TYPES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_LEAVE_TYPES_FAIL:
      return { ...state, loading: false, error: action.payload };

    case FETCH_USER_LEAVE_TYPES_REQUEST:
      return { ...state, userLoading: true, userError: null, userData: [] };
    case FETCH_USER_LEAVE_TYPES_SUCCESS:
      return { ...state, userLoading: false, userData: action.payload, userError: null };
    case FETCH_USER_LEAVE_TYPES_FAIL:
      return { ...state, userLoading: false, userData: [], userError: action.payload };
    case CLEAR_USER_LEAVE_TYPES:
      return { ...state, userLoading: false, userData: [], userError: null };

    default:
      return state;
  }
};

export default LeaveTypeReducer;